import React from 'react';
import { Alert, Box, Chip, Divider, Stack, Typography } from '@mui/material';

export const LegalPage: React.FC<{
  title: string;
  updated: string;
  eyebrow?: string;
  intro?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, updated, eyebrow = 'RIDESAATHI LEGAL', intro, children }) => (
  <Box>
    <Box sx={{ background: 'linear-gradient(135deg,#061b31,#0b3156)', py: { xs: 9, md: 12 }, px: 3, textAlign: 'center' }}>
      <Stack alignItems="center" spacing={1.75}>
        <Chip
          label={eyebrow}
          sx={{ bgcolor: 'rgba(255,201,40,0.12)', color: '#ffc928', fontWeight: 800, letterSpacing: 1 }}
        />
        <Typography variant="h2" fontWeight={900} color="white" sx={{ fontSize: { xs: '2rem', md: '2.8rem' }, maxWidth: 760 }}>
          {title}
        </Typography>
        <Typography variant="body1" color="rgba(226,232,240,0.68)">Last updated: {updated}</Typography>
        {intro && (
          <Typography variant="body1" color="rgba(226,232,240,0.78)" lineHeight={1.8} maxWidth={760}>
            {intro}
          </Typography>
        )}
      </Stack>
    </Box>

    <Box sx={{ maxWidth: 920, mx: 'auto', px: { xs: 2.5, md: 6 }, py: { xs: 6, md: 9 } }}>
      <Stack spacing={4}>
        {children}
      </Stack>
    </Box>
  </Box>
);

export const LegalSection: React.FC<{ title: string; id?: string; children: React.ReactNode }> = ({ title, id, children }) => (
  <Box component="section" id={id}>
    <Typography variant="h5" fontWeight={900} mb={1.5}>{title}</Typography>
    {children}
    <Divider sx={{ mt: 4 }} />
  </Box>
);

export const LegalP: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="body1" color="text.secondary" lineHeight={1.85} mb={1.5}>{children}</Typography>
);

export const LegalList: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <Box component="ul" sx={{ pl: 2.5, mt: 0.5, mb: 1.5, color: 'text.secondary' }}>
    {items.map((item, index) => (
      <Typography key={index} component="li" variant="body1" lineHeight={1.85} sx={{ mb: 0.75 }}>
        {item}
      </Typography>
    ))}
  </Box>
);

export const LegalNotice: React.FC<{ children: React.ReactNode; severity?: 'info' | 'warning' }> = ({ children, severity = 'info' }) => (
  <Alert severity={severity} sx={{ borderRadius: 2, alignItems: 'flex-start' }}>
    <Typography variant="body2" lineHeight={1.75}>{children}</Typography>
  </Alert>
);
